const DEFAULT_BLOB_BASE = 'http://127.0.0.1:10000/devstoreaccount1'

export const buildBlobUrl = (path) => {
  if (!path) {
    return null
  }

  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path
  }

  const base = (import.meta.env.VITE_BLOB_BASE_URL || DEFAULT_BLOB_BASE).replace(/\/$/, '')
  const normalizedPath = path.startsWith('/') ? path.slice(1) : path

  return `${base}/${normalizedPath}`
}
